import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Oval } from "react-loader-spinner";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import axios from "axios";
import Select from "react-select";
import Swal from "sweetalert2";

const styles = {
  // control: (base) => ({ ...base, borderColor: "lightgray" }),
  // input: (base) => ({ ...base, fontWeight: 400 }),
  // valueContainer: (base) => ({ ...base, fontWeight: 400 }),
  menu: (baseStyles, state) => ({
    ...baseStyles,
    marginTop: -5,
    zIndex: 999,
  }),
};

const SubCategory = () => {
  const [categoryDrp, setCategoryDrpData] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categoryId, setCategoryId] = useState(null);

  const getCategoryDrp = () => {
    axios.post(API_URL.CATEGORY_LIST, {}).then((res) => {
      setCategoryDrpData(res.data.data);
      let cd = res.data.data.map((caw) => {
        return {
          label: caw.name,
          value: caw.id,
        };
      });
      setCategoryDrpData(cd);
    });
  };

  const getSubCategory = (category_id = null) => {
    axios.post(API_URL.SUB_CATEGORY_LIST, { is_seller: [0, 1], category_id: category_id }).then(
      (res) => {
        if (res.data.status === 1) {
          setSubCategoryData(res.data.data);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        toast.error("Something went wrong..", {
          autoClose: 3000,
          
        });
      }
    );
  };

  const updateCategorySequence = (id, sequence) => {
    axios.post(API_URL.SUB_CATEGORY_SEQUENCE, { id: id, sequence: sequence}).then(
      (res) => {
        if (res.data.status === 1) {
          toast.success("Sub Category Sequence Updated Successfully", { autoClose: 3000 });
          setSubCategoryData(subCategoryData.map((r) => r.id == id ? { ...r, sequence: sequence } : r));
        } else {
          toast.error(res.data.data, { autoClose: 3000 });
        }
      },
      (error) => {
        console.log(error.response.data)
        toast.error(error.response.data.message, {
          autoClose: 3000,
        });
      }
    );
  };

  const deleteSubCategory = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this - " + row.name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.SUB_CATEGORY_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              let newData = subCategoryData.filter((r) => r.id != row.id);
              setSubCategoryData(newData);
            toast.success("Delete Successfully", { autoClose: 3000 });
            } else {
                toast.error(res.data.data, { autoClose: 3000 });
            }
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", { autoClose: 3000 });
          }
        );
      }
    });
  };

  const updateSubCategoryStatus = (id, status, name) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to " + (status == 1 ? "show" : "hide") + " this - " + name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, " + (status == 1 ? "show" : "hide") + " it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.SUB_CATEGORY_UPDATE_STATUS, { id: id, active: status }).then(
          (res) => {
            if (res.data.status === 1) {
              let newData = subCategoryData.map((r) => r.id == id ? { ...r, active: status } : r);
              setSubCategoryData(newData);
              toast.success("Status Updated Successfully", { autoClose: 3000 });
            } else {
                toast.error(res.data.data, { autoClose: 3000 });
            }
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", { autoClose: 3000 });
          }
        );
      }
    });
  };

  useEffect(() => {
    getSubCategory();
    getCategoryDrp();
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-6">
          <h1>
            Sub Category{" "}
            <small className="me-2">({subCategoryData.length})</small>
          </h1>
        </div>
        <div className="col-4">
          <div className="form-group">
            <Select
              placeholder="Select Category"
              className="form-control-sm"
              options={categoryDrp}
              value={categoryDrp.find((r) => r.value == categoryId)}
              styles={styles}
              onChange={(e) => {
                setCategoryId(e.value);
                getSubCategory(e.value);
              }}
            />
          </div>
        </div>
        <div className="col-2">
          <div className="d-flex align-items-center  justify-content-end">
            <Link to={"/subcategory/add"} className="btn btn-primary">
              <i className="fa fa-plus-circle me-2" aria-hidden="true"></i> Add
              SubCategory
            </Link>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="card">
            <div className="card-body p-0">
              {loading ? (
                <Oval
                  height={60}
                  width={60}
                  color="#7539ff"
                  wrapperStyle={{ justifyContent: "center" }}
                  wrapperClass=""
                  visible={true}
                  ariaLabel="oval-loading"
                  secondaryColor="#7539ff"
                  strokeWidth={2}
                  strokeWidthSecondary={2}
                />
              ) : (
                <div className="table-responsive">
                  <table className="table">
                    <thead className="">
                      <tr>
                        <th>#</th>
                        <th style={{ width: "150px" }}>Image</th>
                        <th>Name</th>
                        <th>Category</th>
                        <th width="100px">Position</th>
                        <th className="text-center" style={{ width: "200px" }}>
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {subCategoryData.map((row, key) => {
                        return (
                          <tr key={key}>
                            <td style={{ width: "30px" }}>{key + 1}</td>
                            <td>
                              <div
                                style={{
                                  height: "50px",
                                  maxWidth: "50px",
                                  backgroundImage: "url(" + row.image + ")",
                                  backgroundSize: 'contain'
                                }}
                              ></div>
                            </td>
                            <td>{row.name}</td>
                            <td>{row?.category.name}</td>
                            <td>
                              <input type="number" value={row.sequence} onChange={(e) => updateCategorySequence(row.id, e.target.value)} className="form-control" />
                            </td>
                            <td
                              className="d-flex justify-content-center gap-2"
                              style={{ width: "200px" }}
                            >
                              <Link
                                to={"/subcategory/edit/" + row.id}
                                className="btn btn-sm btn-secondary mr-2"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </Link>
                              { row.active == 1 && <button
                                onClick={() => updateSubCategoryStatus(row.id, 0, row.name)}
                                className="btn btn-sm btn-warning mr-2"
                              >
                                <i className="fa fa-eye-slash me-1"></i> Hide
                              </button>
                              }
                              { row.active == 0 && <button
                                onClick={() => updateSubCategoryStatus(row.id, 1, row.name)}
                                className="btn btn-sm btn-success mr-2"
                              >
                                <i className="fa fa-eye me-1"></i> Show
                              </button>
                              }
                              <button
                                onClick={() => deleteSubCategory(row)}
                                className="btn btn-sm btn-danger"
                              >
                                <i className="fa fa-trash me-1"></i> Delete
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubCategory;
